module.exports = __webpack_public_path__ + "Participant Email Template - Wave 3.pdf";